import React from "react";
import DraggableModal from "../UI/DraggableModal";
import MaterialTable from "material-table";
import {modifyDefaultOptions} from "../../helpers/table";
import moment from "moment";
import {tableIcons} from "../../helpers";
import {Button, Modal} from "react-bootstrap";

type HistoryItem = {
    createdOn: string,
    isResponsible: boolean,
    new: any,
    old: any,
    oper: string,
    rowNum: number,
    createdBy: any
}

interface PersonsHistoryModalProps {
    show: boolean,
    onHide: () => void,
    history: HistoryItem[]
}

export default function PersonsHistoryModal({show, onHide, history}: PersonsHistoryModalProps) {

    return <DraggableModal
        show={show}
        onHide={onHide}
        headerNode={'История назначения ответственных и представителей ответственных'}
        size='xl'
        centered
    >
        <Modal.Body className='p-3'>
            <MaterialTable
                columns={[
                    {
                        title: 'Дата, время',
                        field: 'createdOn',
                        render: rowData => moment(rowData.createdOn).format('DD.MM.YYYY, hh:mm'),
                        cellStyle: {
                            minWidth: 190,
                            borderBottom: '1px solid #DEE2E6'
                        },
                        customSort: (first, second) => {
                            const firstDate = new Date(first.createdOn);
                            const secondDate = new Date(second.createdOn);
                            return firstDate.getTime() - secondDate.getTime();
                        },
                        headerStyle: {
                            borderBottom: '1px solid black',
                            paddingBottom: 16
                        },
                        defaultSort: 'desc'
                    },
                    {
                        title: 'Пользователь',
                        field: '',
                        cellStyle: {
                            minWidth: 200,
                            borderBottom: '1px solid #DEE2E6'
                        },
                        render: rowData => {
                            const user = rowData.createdBy
                            return <p>{user.lastName} {user.firstName} {user.middleName || ''}</p>
                        },
                        sorting: false,
                        headerStyle: {
                            borderBottom: '1px solid black',
                            paddingBottom: 16
                        },
                    },
                    {
                        title: 'Действие',
                        field: 'oper',
                        cellStyle: {
                            minWidth: 70,
                            borderBottom: '1px solid #DEE2E6'
                        },
                        sorting: false,
                        headerStyle: {
                            borderBottom: '1px solid black',
                            paddingBottom: 16
                        },
                    },
                    {
                        title: 'Изменение',
                        field: 'change',
                        render: rowData => renderChanges(rowData),
                        cellStyle: {
                            minWidth: 530,
                            borderBottom: '1px solid #DEE2E6'
                        },
                        sorting: false,
                        headerStyle: {
                            borderBottom: '1px solid black',
                            paddingBottom: 16
                        },
                    }
                ]}
                data={history}
                options={modifyDefaultOptions({
                    filtering: false,
                    toolbar: false,
                    maxBodyHeight: 'calc(100vh - 250px)',
                })}
                icons={tableIcons}
            />
        </Modal.Body>
        <Modal.Footer>
            <div className='d-flex justify-content-end align-items-center'>
                <Button
                    variant='outline-primary'
                    onClick={onHide}
                    style={{fontWeight: 600}}
                >ОК</Button>
            </div>
        </Modal.Footer>
    </DraggableModal>
}


function renderChanges(item: HistoryItem) {
    const oldUser = item.old?.user;
    const newUser = item.new.user;
    if (['Создание', 'Изменение'].includes(item.oper)) {
        return <div>
            {oldUser && oldUser.guid !== newUser.guid && <p>
              Фио {!item.isResponsible && 'представителя '}ответственного: <span
              className='text-decoration-line-through'>
                {renderUserName(oldUser)}
            </span>
            </p>}
            <p>Фио {!item.isResponsible && 'представителя '}ответственного: {renderUserName(newUser)}</p>
            <p>Дата назначения: {oldUser && oldUser.guid === newUser.guid && <span>
                  <span>{renderDate(item.old.startDate)}</span> &rarr;
                </span>
            } {renderDate(item.new.startDate)}
            </p>
        </div>
    }
    return <div>
        <p>Фио {!item.isResponsible && 'представителя '}ответственного: {renderUserName(newUser)}</p>
        <p>Дата удаления: {renderDate(item.new.startDate)}</p>
    </div>
}

function renderUserName(user: any) {
    return `${user.lastName} ${user.firstName} ${user.middleName || ''}`
}

function renderDate(date: string | null) {
    return date ? moment(date).format('DD.MM.YYYY') : 'Не указано'
}
